var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"video-player-full-text",domProps:{"innerHTML":_vm._s(_vm.props.fullText)}})}
var staticRenderFns = []

export { render, staticRenderFns }